import { InvoiceFilter } from '@vy/types';
import { InvoicesHighlightsSummary } from '@vy/api-definition';
import { isEmptyArray, isNotNullOrUndefined, isNullOrUndefined, Nullable } from '@vy/utils';

import { InvoicesHighlightsSkeleton } from './InvoicesHighlightsSkeleton';
import { DateBasedView } from './DateBasedView';
import { FilterBasedView } from './FilterBasedView';

import { FilterLineType } from '../../../../../components/new-design/vyTableFilter';

export type InvoicesHighlightsProps = {
  filters: Nullable<InvoiceFilter[]>;
  dates: Nullable<{ month: string; year: number }[]>;
  invoicesCount: number;
  invoicesHighlightsSummary?: InvoicesHighlightsSummary;
  invoicesLoading?: boolean;
  onFilterClick?: (filterLines: FilterLineType[]) => void;
};

export const InvoicesHighlights: React.FC<InvoicesHighlightsProps> = (props) => {
  const { filters, dates, invoicesLoading } = props;
  const isFiltersEmpty = isNullOrUndefined(filters) || isEmptyArray(filters);
  const hasDates = isNotNullOrUndefined(dates) && !isEmptyArray(dates);
  const isDateBasedView = isFiltersEmpty && hasDates;

  if (invoicesLoading) {
    return <InvoicesHighlightsSkeleton />;
  }

  if (isDateBasedView) {
    return <DateBasedView {...props} />;
  }

  return <FilterBasedView {...props} />;
};
